import { __assign } from "tslib";
import React, { useState, useCallback } from 'react';
import Popover from '@mui/material/Popover';
import { Button } from 'react-bootstrap';
import getColor from './getColors';
import ColorSolido from './Seleccionar/Color';
export function ButtonColor(p) {
    var tip = p.tip, click = p.click, _a = p.invert, invert = _a === void 0 ? false : _a, style = p.style, className = p.className, color = p.color, children = p.children, _b = p.disable, disable = _b === void 0 ? false : _b;
    var _c = useState(false), hover = _c[0], setHover = _c[1];
    var _d = useState(null), open = _d[0], setOpen = _d[1];
    var handleClick = useCallback(function (event) { setOpen(event.currentTarget); if (click)
        click(); }, [click]);
    var handleClose = function () { return setOpen(null); };
    return React.createElement(React.Fragment, null,
        React.createElement(Button, { "data-tip": tip, size: 'sm', as: 'label', className: className, onClick: handleClick, style: __assign(__assign({ margin: '0 0 0 0', width: 36, height: 24 }, style), getColor(color, hover, invert)), onMouseEnter: function () { return setHover(true); }, onMouseOut: function () { return setHover(false); } }, children),
        disable ? React.createElement(React.Fragment, null) : React.createElement(Popover, { open: open, anchorEl: open, onClose: handleClose, anchorOrigin: { vertical: 'bottom', horizontal: 'left' } },
            React.createElement(ColorSolido, __assign({}, p))));
}
//# sourceMappingURL=index.js.map